export function isSessionExpired(interval, type) {
  let currentTime = new Date().valueOf();

  let expiryTime = '';
  if (type == 'countries') {
    expiryTime = sessionStorage.getItem('countryExpireTime');
  } else if (type == 'timezones') {
    expiryTime = sessionStorage.getItem('timezoneExpireTime');
  }

  if (!expiryTime || currentTime > parseInt(expiryTime)) {
    let expireTime = new Date().setSeconds(new Date().getSeconds() + interval);
    if (type == 'countries') {
      sessionStorage.setItem('countryExpireTime', JSON.stringify(expireTime));
    } else if (type == 'timezones') {
      sessionStorage.setItem('timezoneExpireTime', JSON.stringify(expireTime));
    }

    return true;
  } else {
    return false;
  }
}
